/**
 * Adapts a react-hook-form fieldState to the `meta` shape the legacy field
 * components (input, textarea, radio, multiple-select-*) still expect, so they
 * can be driven from a Controller without being rewritten.
 */
export const toMeta = (fieldState = {}, formState = {}) => {
  const { error, invalid, isTouched, isDirty } = fieldState;
  const hasError = Boolean(invalid || error);

  return {
    error: typeof error === 'object' && error !== null ? error.message : error,
    invalid: hasError,
    valid: !hasError,
    touched: Boolean(isTouched),
    isTouched: Boolean(isTouched),
    isDirty: Boolean(isDirty),
    isSubmitted: Boolean(formState.isSubmitted),
    submitFailed: Boolean(formState.isSubmitted && !formState.isValid)
  };
};
